export default {
  pt: {
    'cadastros.resourceListPage.removed': '{{resource}} removido.',
    'cadastros.resourceListPage.newCategory': 'Nova categoria',
    'cadastros.resourceListPage.searchPlaceholder': 'Buscar {{resource}}…',
    'cadastros.resourceListPage.deleteTitle': 'Excluir {{resource}}?',
    'cadastros.resourceListPage.deleteMessage': 'Tem certeza que deseja excluir "{{name}}"? Esta ação não pode ser desfeita.',
    'cadastros.export.dica': 'Baixa o cadastro filtrado inteiro, com todos os campos da ficha',
    'cadastros.export.vazio': 'Nada para baixar com os filtros atuais.',
  },
  en: {
    'cadastros.resourceListPage.removed': '{{resource}} removed.',
    'cadastros.resourceListPage.newCategory': 'New category',
    'cadastros.resourceListPage.searchPlaceholder': 'Search {{resource}}…',
    'cadastros.resourceListPage.deleteTitle': 'Delete {{resource}}?',
    'cadastros.resourceListPage.deleteMessage': 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    'cadastros.export.dica': 'Downloads the whole filtered register, with every field of the record',
    'cadastros.export.vazio': 'Nothing to download with the current filters.',
  },
  es: {
    'cadastros.resourceListPage.removed': '{{resource}} eliminado.',
    'cadastros.resourceListPage.newCategory': 'Nueva categoría',
    'cadastros.resourceListPage.searchPlaceholder': 'Buscar {{resource}}…',
    'cadastros.resourceListPage.deleteTitle': '¿Eliminar {{resource}}?',
    'cadastros.resourceListPage.deleteMessage': '¿Seguro que desea eliminar "{{name}}"? Esta acción no se puede deshacer.',
    'cadastros.export.dica': 'Descarga todo el registro filtrado, con todos los campos de la ficha',
    'cadastros.export.vazio': 'Nada para descargar con los filtros actuales.',
  },
}
